import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

export const PricingPageFallback = () => {
    return (
        <div
            css={css({
                height: "50vh",
                display: "flex",
                alignItems: "center"
            })}
        >
            <FormattedMessage
                id="PageFallback.message"
                defaultMessage="An unexpected error occurred. Please try again later."
            />
        </div>
    );
};
